import { Component, OnInit,ElementRef, ViewChild, OnDestroy } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Router } from '@angular/router';
import { EncryptDecryptParametersServiceService } from 'src/app/core/service/encrypt-decrypt-parameters-service.service';

@Component({
  selector: 'app-prescripiton-token',
  templateUrl: './prescripiton-token.component.html',
  // styleUrls: ['./prescripiton-token.component.sass']
  styles: [`
      .content {
      width: 4in;
      margin-left: 40%;
      margin-right: -20%
    }
  .invoice-POS {
    box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
    padding: 2mm;
    margin: 0 auto;
    width: 4in;
    background: #fff;
  }
  .invoice-POS ::selection {
    background: #f31544;
    color: #fff;
  }
  .invoice-POS ::moz-selection {
    background: #f31544;
    color: #fff;
  }
  .invoice-POS h1 {
    font-size: 1.5em;
    color: #222;
  }
  .invoice-POS h2 {
    font-size: 0.9em;
  }
  .invoice-POS h3 {
    font-size: 1.2em;
    font-weight: 300;
    line-height: 2em;
  }
  .invoice-POS p {
    font-size: 0.7em;
    color: #666;
    line-height: 1.2em;
  }
  .invoice-POS #top,
  .invoice-POS #mid,
  .invoice-POS #bot {
    /* Targets all id with 'col-' */
    border: 1px solid #eee;
  }
  .invoice-POS #top {
    min-height: 100px;
  }
  .invoice-POS #mid {
    min-height: 80px;
  }
  .invoice-POS #bot {
    min-height: 50px;
  }
  .invoice-POS #top .logo {
    height: 60px;
    width: 60px;
    background: url(http://michaeltruong.ca/images/logo1.png) no-repeat;
    background-size: 60px 60px;
  }
  .invoice-POS .clientlogo {
    float: left;
    height: 60px;
    width: 60px;
    background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
    background-size: 60px 60px;
    border-radius: 50px;
  }
  .invoice-POS .info {
    display: block;
    margin-bottom: 70px;
    margin-top: 70px;
  }
  .tno {
      font-size: 55px;
      text-align: center;
      margin-bottom: 60px;
      margin-top: 60px;
  }
  .tname {
    font-size: 25px;
  }
  .tdate {
    font-size: 25px;
    text-align: right;
  }
  
  .watermark {
    font-size: 100px;
    bottom: 107px;
    left: 243px;
    text-align: right;
    pointer-events: none;
    user-select: none;
    position: relative;
    color: #9f9f9f;
    opacity: 0.2;
  }
  .watermark-img{
    height: auto;
      width: 200px;
  }
  
  .rotate {
    
    -moz-transform: rotate(-90.0deg);  /* FF3.5+ */
      -o-transform: rotate(-90.0deg);  /* Opera 10.5 */
  -webkit-transform: rotate(-90.0deg);  /* Saf3.1+, Chrome */
            filter:  progid:DXImageTransform.Microsoft.BasicImage(rotation=0.083);  /* IE6,IE7 */
        -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0.083)"; /* IE8 */
  }
  
  .rotate_watermark
  {
    position: absolute;
    -moz-transform: rotate(300deg);  /* FF3.5+ */
    -o-transform: rotate(300deg);  /* Opera 10.5 */
  -webkit-transform: rotate(300deg);  /* Saf3.1+, Chrome */
          filter:  progid:DXImageTransform.Microsoft.BasicImage(rotation=0.083);  /* IE6,IE7 */
      -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0.083)"; /* IE8 */
  }
  .invoice-POS .title {
    float: right;
  }
  .invoice-POS .title p {
    text-align: right;
  }
  .invoice-POS table {
    width: 100%;
    border-collapse: collapse;
  }
  .invoice-POS .tabletitle {
    font-size: 0.5em;
    background: #eee;
  }
  .invoice-POS .service {
    border-bottom: 1px solid #eee;
  }
  .invoice-POS .item {
    width: 24mm;
  }
  .invoice-POS .itemtext {
    font-size: 0.5em;
  }
  .invoice-POS #legalcopy {
    margin-top: 5mm;
  }
  `]
})
export class PrescripitonTokenComponent implements OnInit,OnDestroy {

  @ViewChild('pdfTable')
  pdfTable!: ElementRef;

  constructor(private router: Router,
    private encryptDecryptParametersService: EncryptDecryptParametersServiceService,) {  
    let DATA: any = document.getElementById('pdfTable');
    html2canvas(DATA).then((canvas) => {
      let fileWidth = 80;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('angular-demo.pdf');
    });

  }

  ngOnInit(): void {
    const finalURL =
    this.router.url.split("?")[0] +
    "?" +
    this.encryptDecryptParametersService.decrypt(this.router.url);
  var data = JSON.parse(
    this.encryptDecryptParametersService.getQueryParams("details", finalURL)
  );
  var newdata = data;
  
  }

  ngOnDestroy() {
    this.downloadAsPDF();
  }
  public downloadAsPDF(): void {
    let DATA: any = document.getElementById('pdfTable');
    html2canvas(DATA).then((canvas) => {
      let fileWidth = 80;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('angular-demo.pdf');
    });
  }

}
